<div class="d-flex align-items-center" paceCoreValidationMessage [validation]="checkboxControl">
    <div [ngClass]="{ 'readonly-input-control': isReadonlyInputControl }" class="checkbox-container">
        <input
            type="checkbox"
            [formControl]="checkboxControl"
            class="form-control"
            [id]="checkBoxID"
            [attr.aria-label]="ariaLabel"
        />
        @if (this.model.value) {
            <fa-icon [icon]="faCheck" size="2x"></fa-icon>
        }
    </div>
    @if (model.options && model.options.showLabel) {
        <label class="ms-2 mb-0" [for]="checkBoxID">{{ model.displayName }}</label>
    }
</div>
